var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['px-8 rounded-full flex items-center justify-center text-xs font-semibold uppercase', _vm.getStatus]},[(!_vm.isSlotMessage)?[_vm._v(_vm._s(_vm.statusMessage))]:_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }